import React from "react";
import clsx from "clsx";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  allowDecimal?: boolean;
  dataTestId?: string;
  className?: string;
  icon?: boolean;
  imageName?: string;
  startIcon?: any;
  forceDecimal?: boolean;
  negativeOnly?: boolean;
  negativeLabel?: boolean;
  iconOnClick?: () => void;
}

const onForceDecimal = (e: any) => {
  return (e.target.value = e.target.valueAsNumber.toFixed(2));
};

// FIXME: remove w-full
const BASE_STYLES =
  "border border-input-border font-medium rounded-lg text-text-primary outline-none bg-input-bg text-[14px] py-2 px-3.5 w-full h-10 transition-all duration-200 focus:border-indigo-400/40 focus:ring-2 focus:ring-indigo-400/20 placeholder:text-light-gray disabled:opacity-70 disabled:cursor-not-allowed";

const CustomInput = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      label,
      id,
      error,
      disabled,
      helperText,
      className,
      allowDecimal,
      dataTestId,
      icon,
      imageName,
      startIcon,
      forceDecimal,
      negativeOnly,
      negativeLabel,
      iconOnClick,
      ...props
    }: InputProps,
    ref
  ) => {
    const allowStep = allowDecimal && props.type === "number";

    return (
      <div className="w-full">
        {label ? (
          <label
            className="text-[12px] font-medium text-light-gray block mb-1.5"
            data-testid="input-label"
            htmlFor={id}
          >
            {label}
          </label>
        ) : null}
        <div className="relative">
          {startIcon ? (
            <p className="absolute left-3 top-1/2 -translate-y-1/2 text-[14px] text-light-gray font-medium pointer-events-none">
              {startIcon}
            </p>
          ) : null}
          {negativeLabel ? (
            <p className="absolute left-7 top-1/2 -translate-y-1/2 text-[14px] text-light-gray font-medium pointer-events-none">
              -
            </p>
          ) : null}
          <input
            {...props}
            data-testid={dataTestId}
            aria-invalid={!!error}
            disabled={disabled}
            aria-disabled={disabled}
            id={id}
            step={allowStep ? "0.01" : undefined}
            ref={ref}
            onBlur={forceDecimal ? onForceDecimal : null}
            onInput={
              negativeOnly
                ? (e: any) => (e.target.value = -Math.abs(e.target.value))
                : null
            }
            className={clsx(
              BASE_STYLES,

              className,
              error && "border-ilara-red ring-1 ring-red-400/40",
              startIcon && "!pl-8",
              startIcon && negativeLabel && "!pl-10"
            )}
          />
        </div>
        {icon ? (
          <img
            src={imageName}
            className="w-4 h-4 absolute top-0 !mt-8 mr-8 flex justify-center items-center right-0 cursor-pointer"
            alt=""
            onClick={iconOnClick}
          />
        ) : null}
        {error || helperText ? (
          <p
            className={`${
              error ? "text-red-500" : "text-ilara-secondary-text"
            } text-[12px] font-medium mt-1.5`}
            data-testid={error ? "input-error" : "input-helper-text"}
          >
            {error || helperText}
          </p>
        ) : null}
      </div>
    );
  }
);

export default CustomInput;
